import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'environments/environment';

/** Header that carries the token of a Wi-Fi invitation. */
export const WIFI_TOKEN_HEADER = 'X-Wifi-Setting-Token';

@Injectable({
    providedIn: 'root',
})
export class WifiSettingsService {
    protected repoURL = environment.repoUrl;

    constructor(private http: HttpClient) {}

    /**
     * The invitation token travels in a header, not in the address (BSI TR-03161-2 O.Source_11): an address ends up
     * in the logs of servers and proxies and in the browser history.
     */
    isValidWifiSettingsToken(token: string): Observable<any> {
        return this.http.get<any>(
            `${this.repoURL}/api/wifi-setting-token/is-valid`,
            { headers: { [WIFI_TOKEN_HEADER]: token } }
        );
    }

    setWifiPassword(token: string, payload): Observable<any> {
        return this.http.post<any>(
            `${this.repoURL}/api/wif-setting/wifi-setting-token`,
            payload,
            { headers: { [WIFI_TOKEN_HEADER]: token } }
        );
    }

    //     POST
    // /api/user/{userId}/wifi-settings/{deviceUuid}

    // POST
    // /api/user/{userId}/wifi-settings/request-via-sms/user-id/{targetUserId}
    sendtWifiPasswordRequestViaSmsWithTargetUser(
        userId: number,
        targetUserId: number
    ): Observable<any> {
        return this.http.post<any>(
            `${this.repoURL}/api/user/${userId}/wifi-settings/request-via-sms/user-id/${targetUserId}`,
            { params: { userId, targetUserId }, observe: 'response' }
        );
    }

    // POST
    // /api/user/{userId}/wifi-settings/request-via-email/user-id/{targetUserId}
    sendtWifiPasswordRequestViaEmailWithTargetUser(
        userId: number,
        targetUserId: number
    ): Observable<any> {
        return this.http.post<any>(
            `${this.repoURL}/api/user/${userId}/wifi-settings/request-via-email/user-id/${targetUserId}`,
            { params: { userId, targetUserId }, observe: 'response' }
        );
    }

    // POST
    // /api/user/{userId}/wifi-settings/request-via-sms/phone-number/{phoneNumber}
    sendtWifiPasswordRequestViaSms(
        userId: number,
        phoneNumber: string
    ): Observable<any> {
        return this.http.post<any>(
            `${this.repoURL}/api/user/${userId}/wifi-settings/request-via-sms/phone-number/${phoneNumber}`,
            { params: { userId, phoneNumber }, observe: 'response' }
        );
    }

    // POST
    // /api/user/{userId}/wifi-settings/request-via-email/email/{targetEmail}
    sendtWifiPasswordRequestViaEmail(
        userId: number,
        targetEmail: string
    ): Observable<any> {
        return this.http.post<any>(
            `${this.repoURL}/api/user/${userId}/wifi-settings/request-via-email/email/${targetEmail}`,
            { params: { userId, targetEmail }, observe: 'response' }
        );
    }
}
